import { put } from 'redux-saga/effects';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';

const key = 'REGION/NEIGHBORHOOD/LIST';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetNeighborhood(client, { payload }) {
  try {
    const response = yield client.post('/region/list', { data: payload });
    yield put(actions.loadSuccess(response.result.data));
  } catch (e) {
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
